export default __webpack_public_path__ + "static/media/citizen.3980db45.png";